// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__18E-_","select":"Header_select__2EJXI","clinic":"Header_clinic__l7Cfc"};